import React from 'react';
import styled from 'styled-components';
import { Redirect, useHistory } from 'react-router-dom';
import { FaLock } from 'react-icons/fa';
import { useAppSelector } from '../../store/hooks';
import { podeAcessarRota, telaInicial } from '../../services/acesso';

const Caixa = styled.div`
  max-width: 440px;
  margin: 80px auto;
  padding: 32px 24px;
  text-align: center;
  color: #495057;

  svg {
    color: #adb5bd;
    margin-bottom: 14px;
  }

  h2 {
    font-size: 1.15rem;
    font-weight: 600;
    color: #212529;
    margin-bottom: 8px;
  }

  p {
    font-size: 0.9rem;
    color: #6c757d;
    margin-bottom: 20px;
  }

  button {
    border: none;
    border-radius: 8px;
    padding: 8px 18px;
    background: #1F467E;
    color: white;
    font-weight: 500;
  }
`;

export const SemAcesso: React.FC = () => {
    const history = useHistory();
    const token = useAppSelector(state => state.token);
    const destino = telaInicial(token);
    return (
        <Caixa>
            <FaLock size={34} />
            <h2>Você não tem acesso a esta tela</h2>
            <p>Peça ao administrador da sua empresa para liberar o acesso em Cadastros, Usuário, na etapa Permissões.</p>
            {destino && <button type="button" onClick={() => history.push(destino)}>Voltar ao início</button>}
        </Caixa>
    );
};

const envolvidos = new Map<React.ComponentType<any>, React.FC<any>>();

/**
 * Tela da rota só para quem tem a permissão de ver (PERMISSOES_DA_ROTA); os demais vão para a primeira tela que
 * podem abrir (ou veem SemAcesso, se não podem nenhuma) e a tela nem monta, então não dispara consultas que a API
 * recusaria. Memoizado para a rota não remontar a cada render.
 */
export function comPermissao<P>(Componente: React.ComponentType<P>): React.FC<P> {
    const existente = envolvidos.get(Componente);
    if (existente) return existente;

    const Protegido: React.FC<any> = (props) => {
        const token = useAppSelector(state => state.token);
        const rota = props.match?.path ?? props.location?.pathname;
        if (podeAcessarRota(token, rota)) return <Componente {...props} />;
        const destino = telaInicial(token);
        return destino ? <Redirect key={props.location?.key ?? rota} to={destino} /> : <SemAcesso />;
    };
    Protegido.displayName = `comPermissao(${Componente.displayName || Componente.name || 'Tela'})`;
    envolvidos.set(Componente, Protegido);
    return Protegido;
}
